
<template>
  <div>
    <el-header>
      <page-head :isApplyPage="true"></page-head>
    </el-header>
    <div class="applybox" v-loading="pageloading">
      <el-steps class="stepStyle" :active="stepActive" align-center finish-status="success">
        <el-step :title="$t('m.agency_reginfo_fill')" ></el-step>
        <el-step :title="$t('m.audit_res')"></el-step>
      </el-steps>
      <div class="applyform">
        <apply-form @updateStepActive="updateStepActive" v-if="stepActive==0"></apply-form>
        <apply-result :applyState="applyState" @updateStepActive="updateStepActive" v-else></apply-result>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "@/components/pageHead";
import applyform from "./components/applyform";
import applyResult from "./components/applyResult";
import { getApplySeatus } from '@/api/apply';
  export default {
    name: "apply-index",
    components: {
        "page-head": pageHead,
        "apply-form": applyform,
        "apply-result": applyResult,
    },
    data() {
      return {
        pageloading:true,
        stepActive:0,
        applyState:{
          guildId:null,
          state:0,//0：待审核，1：通过，2：未通过	
          rejectReason:null
        },
      }
    },
    watch:{
      
    },
    mounted(){
      this.stepActive=this.$route.params.stepActive||0;
      this.getApplySeatus();
    },
    methods:{
      
     updateStepActive(i){
      console.log(i);
       if(!i&&i!==0)return false;
       this.stepActive=i;
       if(i>=1){
         this.getApplySeatus();
       }
     },
    //  获取用户申请状态
     getApplySeatus(){
      this.pageloading=true;
        getApplySeatus()
        .then(({data}) => {
          this.pageloading=false;
          if(data.data&&data.data.state||data.data.state==0){
            this.stepActive=1;
            if(data.data.state==1){
              this.stepActive=2;
            }
            this.applyState=data.data;
          }else{
            this.stepActive=0
          }
        })
        .catch(error => {
          this.pageloading=false;
        });
     },
     
    },
  };
</script>
<style lang="scss">
  .applyform{
      .el-form-item{
        display: flex;
        align-items: center;
        &__label{
          line-height: 1.2;
          padding-top: 7px;
        }
        &__content{
          margin-left: 0 !important;
          flex: 1;
        }
      }
      .el-select{
        width: 100%;
      }
      .el-form-item__label{
        padding-top: 0;
      }
  }
  .ar{
    .fc-mar-l-min{
      margin-left: 0;
      margin-right: 10px;
    }
    .zhizhaopic .notebox{
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
</style>
<style lang="less" scoped>
  .applybox{
    max-width: 960px;
    margin: auto;
  }
  .stepStyle{
    margin: 30px 0;
  }
  .el-header{
    color: #282828;
    border-bottom: 1px solid #eee;
  }
  .applyform{
    width: 100%;
    padding: 20px;
    max-width: 700px;
    margin: 0 auto;
    box-sizing: border-box;
  }
@media only screen and (max-width: 767px) {
  .applyform{
    padding: 20px 10px 20px 0;
  }
  .el-header{
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/apply/index.vue